<template>
<svg  viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
<g>
</g>
	<path d="M0 7h7v-7h-7v7zM1 1h5v5h-5v-5z" fill="currentColor" />
	<path d="M9 0v7h7v-7h-7zM15 6h-5v-5h5v5z" fill="currentColor" />
	<path d="M0 16h7v-7h-7v7zM1 10h5v5h-5v-5z" fill="currentColor" />
	<path d="M9 16h7v-7h-7v7zM10 10h5v5h-5v-5z" fill="currentColor" />
</svg>
</template>